import React from "react";
import "./Adminhome.css";
import BannerSection from './BannerSection';
import AdsSection from './AdsSection';

const Adminhome = () => {
  return (
    <div className="vx-page-wrapper">
      <div className="vx-layout-grid">

        {/* Main Column (8) */}
        <main className="vx-main-content vx-col-8">
          <BannerSection/>
        </main>

        {/* Right Column (3) */}
        <aside className="vx-right-panel vx-col-3">
          <AdsSection/>
        </aside>

      </div>
    </div>
  );
};

export default Adminhome;
